import React, { useState } from "react";
import SecondaryMenu from "../shared/SecondaryMenu";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import SvgIcon from "@material-ui/core/SvgIcon";
import IconButton from "@material-ui/core/IconButton";
import { useForm, Controller } from "react-hook-form";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import { TextField } from "@material-ui/core";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoIcon from "@material-ui/icons/Info";
import Button from "@material-ui/core/Button";
import "../../style/UserStyleSheet.css";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DeletePopUp from "../shared/DeletePopUp";
import api from "../../store/api";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

interface AddEditReasonsForRescheduleProps {
  Id: string | null;
}

const AddEditReasonsForRescheduleWidget = (
  props: AddEditReasonsForRescheduleProps
): JSX.Element => {
  const { Id } = props;
  const history = useHistory();
  const classes = useStyles();

  const { handleSubmit, errors, control, formState, getValues, setValue } = useForm();

  const [headingText] = useState("Reasons For Reschedule");
  const [errorMessage, setErrorMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);

  const handleBack = () => {
    history.push({
      pathname: "/settings/rescheduleReasons",
    });
  };

  React.useEffect(() => {
    if(Id){
      getReasonForReschedule(Id)
    }
  }, [Id])
  

  const handleDelete = async (): Promise<void> => {
    if (Id) {
      setLoading(true);
      try {
        resetMessages();
        setLoading(true);
        const _res = await api.DeleteReasonForReschedule("reasonForRescheduleId=" + Id,"");
        if (_res !== null && !_res?.hasError) {
          const data = _res?.reasonForRescheduleId;
          setStatusMessage(_res?.message);
          setLoading(false);
        }
        else {
          setErrorMessage(_res?.message);
          setLoading(false);
        }
      }
      catch (error) {
        setLoading(false);
        console.log(error)
      }
      handleBack();
    }
  };

  const resetMessages = () => {
    setErrorMessage("");
    setStatusMessage("");
  };

  const getReasonForReschedule = async (Id:any) => {
    try {
      resetMessages();
      setLoading(true);
      const _res = await api.GetReasonForReschedulebyId("reasonForRescheduleId=" + Id);
      if (_res !== null && _res?.data?.model !== null && !_res?.data?.hasError && _res?.data?.model !== null) {
        const data = _res?.data?.reasonForReschedule;
        setValue("reason",data.name)
        setValue("cause",data.cause === true ? "1":"2")
        setLoading(false);
      }
      else{
        setErrorMessage(_res?.data?.message);
        setLoading(false);
      }
    }
    catch (error) {
      setLoading(false);
      console.log(error)
    }
  };

  const UpdateReasonForReschedule = async (req : any) => {
    try {
      setLoading(true);
      const _res = await api.UpdateReasonForReschedule("",req);
      if (_res !== null && _res?.model !== null && !_res?.hasError && _res?.model !== null) {
        const data = _res?.model;
        setStatusMessage(_res?.message);
        setLoading(false);
      }
      else{
        setErrorMessage(_res?.message)
        setLoading(false);
      }
    }
    catch (error) {
      console.log(error)
      setLoading(false);
    }
    handleBack();
  };


  const AddReasonForReschedule = async (req : any) => {
    try {
      setLoading(true);
      const _res = await api.AddNewReasonForReschedule("",req);
      if (_res !== null && _res?.model !== null && !_res?.hasError && _res?.model !== null) {
        const data = _res?.model;
        setStatusMessage(_res?.message);
        setLoading(false);
      }
      else{
        setErrorMessage(_res?.message)
        setLoading(false);
      }
    }
    catch (error) {
      console.log(error)
      setLoading(false);
    }
    handleBack();
  };


  const onSubmit = () => {
    const data = getValues();
    const reason = data["reason"];
    const cause = data["cause"] == "1" ? true : false;
    resetMessages();
    const request = {
      reasonForRescheduleId:Id,
      name : reason,
      cause: cause
    }
    if(Id){
      UpdateReasonForReschedule(request)
    }
    else{
      AddReasonForReschedule(request);
    }
    
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
        <div style={{ alignSelf: "stretch", display: "flex" }}>
          <SecondaryMenu selectedmenu="Reasons For Reschedule" />
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          autoComplete="off"
          style={{ width: "100%" }}
        >
          <div style={{ width: "100%" }}>
            <div style={{ paddingTop: 5 }}>
              {loading ? <CreateLoadingLine /> : null}
            </div>
            <div style={{ padding: 40 }}>
              <Grid container spacing={3} className={classes.mainGrid}>
                <Grid item xs={12}>
                  <div className={classes.mainTop}>
                    <IconButton
                      size="small"
                      className={classes.backButton}
                      onClick={handleBack}
                    >
                      <ArrowBackIcon />
                      <span className="backBtn">{headingText}</span>
                    </IconButton>
                    {Id ? (
                      <Button
                        className="changePasswordBtn"
                        variant="contained"
                        onClick={() => setDeletePopup(true)}
                      >
                        Delete
                      </Button>
                    ) : null}
                  </div>
                </Grid>

                <Grid item xs={4}>
                  <div className={classes.textFieldLable}>
                    <span>
                      <StarIcon />
                    </span>
                    REASON
                  </div>
                  <Controller
                    control={control}
                    name="reason"
                    defaultValue=""
                    rules={{
                      required: "Reason is required",
                      validate: (value) => {
                        if (value.trim() === "") {
                          return "Reason cannot be empty";
                        }
                        return true;
                      },
                    }}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{
                          classes: { root: classes.textFieldInput },
                        }}
                        variant="outlined"
                        error={errors.reason}
                        helperText={errors.reason ? errors.reason.message : ""}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    <span>
                      <StarIcon />
                    </span>
                    CAUSE
                  </div>
                  <Controller
                    control={control}
                    name="cause"
                    defaultValue={"1"}
                    render={(props) => (
                      <RadioGroup row {...props} className="">
                        <FormControlLabel
                          control={<Radio color="primary" size="small" />}
                          label="Customer"
                          value="1"
                        />
                        <FormControlLabel
                          control={<Radio color="primary" size="small" />}
                          label="Non-customer"
                          value="2"
                        />
                      </RadioGroup>
                    )}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <div
                className={classes.main}
                style={{ paddingLeft: 40, paddingRight: 40 }}
              >
                <div className={classes.headingAlert}>
                  <Alert
                    variant="filled"
                    icon={<ReportProblemOutlinedIcon />}
                    severity="error"
                    classes={{ root: classes.alertRoot }}
                    style={{ display: errorMessage ? "flex" : "none" }}
                  >
                    {errorMessage}
                  </Alert>
                  <Alert
                    variant="filled"
                    icon={<InfoIcon />}
                    severity="success"
                    classes={{ root: classes.alertRoot }}
                    style={{ display: statusMessage ? "flex" : "none" }}
                  >
                    {statusMessage}
                  </Alert>
                </div>
              </div>
              <div className={classes.formLeft}>
                <Button
                  disabled={formState.isSubmitting}
                  className={classes.formBtn}
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  Save
                </Button>
                <Button
                  className={classes.formBtn}
                  variant="contained"
                  onClick={handleBack}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <DeletePopUp
        isDialogOpen={deletePopup}
        onCancel={() => setDeletePopup(false)}
        onDo={handleDelete}
        title="Delete Reason"
        recordName="reason"
      />
    </>
  );
};

export default React.memo(AddEditReasonsForRescheduleWidget);

const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      viewBox="0 0 11 10"
      style={{ marginRight: 5 }}
    >
      <path
        id="_copy"
        data-name="* copy"
        d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z"
        fill="#f4b827"
      />
    </svg>
  );
};

const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();
  return (
      <div className={classes.loading}>
          <LinearProgress color="primary" />
      </div>
  )
}
const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40,
    flexGrow: 1,
  },
  mainTop: {
    paddingBottom: theme.spacing(4),
  },
  main: {},
  heading: {
    fontSize: 36,
    fontWeight: 900,
    paddingBottom: theme.spacing(2),
  },
  textFieldLable: {
    fontSize: 14,
    fontWeight: 700,
    color: "#949494",
    padding: theme.spacing(0, 0, 1, 0),
  },
  textFieldRoot: {
    width: "100%",
  },
  headingAlert: {
    padding: theme.spacing(0, 0, 2, 0),
  },
  textFieldInput: {
    backgroundColor: "#ECECEC",
    color: "black",
    height: "40px",
  },
  alertRoot: {
    marginTop: 24,
  },
  loading: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  formBtn: {
    margin: theme.spacing(0, 1, 0, 1),
    width: "100px",
    height: "43px",
  },
  testBox: {
    display: "flex",
    alignItems: "center",
    gap: 19,
  },
  testBtn: {
    minWidth: "80px",
    margin: 0,
    height: "39px",
  },
  testMsg: {
    color: "#333333",
    fontSize: 21,
    fontWeight: 400,
  },
  testDateHint: {
    width: 275,
    marginTop: 11,
    color: "#333333",
    fontSize: 14,
    fontWeight: 400,
  },
  formLeft: {
    paddingLeft: 40,
    paddingBottom: 40,
    paddingTop: 0,
  },
  mainGrid: {
    width: "100%",
  },
  backButton: {
    "& .MuiIconButton-label": {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      "& .MuiSvgIcon-root": {
        height: "24px",
        width: "24px",
        fill: "#02489D",
      },
      "& .backBtn": {
        fontFamily: "Lato",
        fontSize: 18,
        fontWeight: 700,
        color: "#02489D",
      },
    },
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  msspace: {
    marginLeft: "38px",
  },
  dateTimePicker: {
    "& h3": {
      fontSize: "3rem",
    },
    "& h4": {
      fontSize: "2rem",
    },
    "& button": {
      minWidth: 0,
    },
  },
  errorText: {
    fontWeight: 400,
    color: "#f44336",
  },
}));
